import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { EnaioExportOptions } from 'src/modules/enaio/shared/EnaioExportOptions';
import { EnaioObjectDef } from 'src/modules/enaio/shared/EnaioObjectDef';
import { EnaioObjectTypeExportParams } from 'src/modules/enaio/shared/EnaioObjectTypeExportParams';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { DhTools } from '../../models/dh-tools.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';

@Component({
  selector: 'app-enaio-export-options',
  templateUrl: './enaio-export-options.component.html',
  styleUrl: './enaio-export-options.component.scss'
})
export class EnaioExportOptionsComponent {

    app = inject(MainAppService);

    @Input()
    def: EnaioObjectDef;

    _options: EnaioExportOptions;

    form: FrontendFormDefinition;
    forms: FrontendFormDefinition[] = [];
    tables: TableData[] = [];

    @Output()
    onAction = new EventEmitter<boolean>();
    @Output()
    optionsChange = new EventEmitter<EnaioExportOptions>();

    @Input()
    set options(value: EnaioExportOptions) {
        this._options = value;

        this.form = value == null ? null : new FrontendFormDefinition([
        ]);

        this.tables = value == null ? [] : value.archives.map(archive => new TableData([
                new TableColumn("export", "Exportieren", TableCellType.yesNo, { autoWidth: 1, editable: true }),
                new TableColumn("objectType", "Objekttyp", TableCellType.text, { autoWidth: 20 }),
                new TableColumn("includeChildren", "Mit Unterlementen", TableCellType.yesNo, { autoWidth: 1, editable: true }),
                new TableColumn("documents", "Mit Dokumenten", TableCellType.yesNo, { autoWidth: 1, editable: true }),
                new TableColumn("overwriteDocumentFiles", "Bestehende Dokumentdateien im Exportverzeichnis überschreiben", TableCellType.yesNo, { autoWidth: 1, editable: true }),
                new TableColumn("exportConditions", "Export Bedingungen", TableCellType.text, { flex: 1, editable: true })
            ], archive.objectTypes.map(ot => new TableRow("", ot, {
                export: ot.export,
                objectType: ot.objectType.objectType.name,
                includeChildren: ot.includeChildren,
                documents: ot.documents,
                overwriteDocumentFiles: ot.overwriteDocumentFiles,
                exportConditions: ot.exportConditions
            }))));
    }

    fromGui(): void {
        this.form.get(this._options);
        for (let i = 0; i < this._options.archives.length; i++) {
            for (let row of this.tables[i].rows) {
                let ot = row.raw as EnaioObjectTypeExportParams;
                ot.export = row.values.export;
                ot.includeChildren = row.values.includeChildren;
                ot.documents = row.values.documents;
                ot.overwriteDocumentFiles = row.values.overwriteDocumentFiles;
                ot.exportConditions = row.values.exportConditions;
            }
        }
    }

    export(): void {
        this.fromGui();
        this.onAction.emit(true);
    }

    async saveConfig(): Promise<void> {
        this.fromGui();
        let fileName = await DhTools.saveDialog("exportConfig.json");
        if (!Utils.isNoe(fileName)) {
            await DhTools.backendCall("api/enaio/exportSaveConfig", { fileName, options: Utils.toJson(this._options)}).getText();
            let config = {
                workers: [
                  {
                    type: "EnaioExportData",
                    exportOptionsFileName: Utils.replaceAll(fileName, "\\\\", "/"),
                    exportDir: "<TODO>"
                  }
                ]
              }
            this.app.messageDialog.textArea("DH-Konfiguration für den Export", Utils.toJson(config, true));
        }
    }

    async loadConfig(): Promise<void> {
        this.fromGui();
        let fileName = await DhTools.openDialog("exportConfig.json");
        if (!Utils.isNoe(fileName)) {
            this.options = await DhTools.backendCall("api/enaio/exportLoadConfig", { fileName, options: Utils.toJson(this._options)}).get(EnaioExportOptions);
            this.optionsChange.emit(this.options);
        }
    }

    cancel(): void {
        this.onAction.emit(false);
    }
}
